module.exports = __webpack_public_path__ + "img/infograph_2.6bc5b0cd.png";